import { render, staticRenderFns } from "./SeguimientoPedido.vue?vue&type=template&id=79ba5a69"
import script from "./SeguimientoPedido.vue?vue&type=script&lang=js"
export * from "./SeguimientoPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports